module.exports = __webpack_public_path__ + "img/img-1-mini.7e7806f0.webp";